/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Sponsor_PlacementInputs */

const en_landing_pricing_feature_sponsor_placement = /** @type {(inputs: Landing_Pricing_Feature_Sponsor_PlacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsor placement on homepage`)
};

const zh_landing_pricing_feature_sponsor_placement = /** @type {(inputs: Landing_Pricing_Feature_Sponsor_PlacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页赞助曝光位`)
};

/**
* | output |
* | --- |
* | "Sponsor placement on homepage" |
*
* @param {Landing_Pricing_Feature_Sponsor_PlacementInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_sponsor_placement = /** @type {((inputs?: Landing_Pricing_Feature_Sponsor_PlacementInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Sponsor_PlacementInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_sponsor_placement(inputs)
	return zh_landing_pricing_feature_sponsor_placement(inputs)
});
export { landing_pricing_feature_sponsor_placement as "landing.pricing.feature_sponsor_placement" }